import { render, staticRenderFns } from "./workLink.vue?vue&type=template&id=30b4d982&"
import script from "./workLink.vue?vue&type=script&lang=js&"
export * from "./workLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports